import { formatPatientId } from '@utils/format';

import type {
  QuestionnaireResponseItemModelInput,
  QuestionnaireResponseModelInput,
} from 'generated/types';

export function getQuestionnaireResponseTemplate(
  patient_id: string,
  responses: QuestionnaireResponseItemModelInput[]
): QuestionnaireResponseModelInput {
  return {
    resourceType: 'QuestionnaireResponse',
    status: 'completed',
    authored: new Date().toISOString(),
    source: {
      reference: formatPatientId(patient_id),
    },
    subject: {
      reference: formatPatientId(patient_id),
    },
    item: responses,
  };
}
